// EmployerCoursesPage — the employer "Moduler" area (/dashboard/courses): the
// reusable course library. Courses are a first-class resource: programs group
// them and needs attach them as prerequisites, so they live in their own area
// (not buried under Onboarding). "Skapa Modul" (the creator) lives here.
// (Onboarding redesign #216 — see ONBOARDING_REDESIGN.md.)
import React, { useState } from 'react';
import { Lightbulb } from 'lucide-react';
import OrganisationModulesSection from './OrganisationModulesSection';
import CreateModuleModal from './CreateModuleModal';
import { ExplainerCard } from '@/components/custom-ui/ExplainerCard';
import { NEXILINK_SPACING } from '@/lib/nexilink-card-styles';

const EmployerCoursesPage: React.FC = () => {
    const [showCreateModuleModal, setShowCreateModuleModal] = useState(false);
    const [modulesRefreshKey, setModulesRefreshKey] = useState(0);

    return (
        <>
            <div className={NEXILINK_SPACING}>
                <ExplainerCard id="employer-courses" icon={Lightbulb} tone="amber" title="Så funkar moduler">
                    <p className="text-sm text-gray-600 mt-0.5">
                        <strong>Moduler</strong> är byggstenarna i din onboarding och kan även krävas som förkunskap vid rekrytering. Skapa en modul med steg en gång och återanvänd den i program och annonser.
                    </p>
                </ExplainerCard>

                <OrganisationModulesSection
                    refreshKey={modulesRefreshKey}
                    onCreate={() => setShowCreateModuleModal(true)}
                />
            </div>

            {showCreateModuleModal && (
                <CreateModuleModal
                    onClose={() => setShowCreateModuleModal(false)}
                    onSuccess={() => {
                        setShowCreateModuleModal(false);
                        setModulesRefreshKey((k) => k + 1);
                    }}
                />
            )}
        </>
    );
};

export default EmployerCoursesPage;
